import { useContext } from 'react';

import Context from './Context';

export default function useCompetitions() {
  return useContext(Context);
}
